/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

const parkingType = Object.freeze({
  PARK_AND_RIDE: "parkAndRide",
  BIKE_PARKING: "bikeParking",
  UNKNOWN: "unknown",
});

export const parkingTypes = Object.values(parkingType);

// Tiamat stores a NeTEx ParkingTypeEnumeration value. Only two of those values
// have a title message. Everything else, and an absent type, gets the fallback.
export const titledParkingTypes = Object.freeze([
  parkingType.PARK_AND_RIDE,
  parkingType.BIKE_PARKING,
]);

export const parkingTitleMessageId = (type) =>
  titledParkingTypes.includes(type)
    ? `parking_item_title_${type}`
    : `parking_item_title_${parkingType.UNKNOWN}`;

export default parkingType;
